export const BRAND_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/BrandUploadTemplate.xlsx';

export const COUPON_GENERATE_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/CouponGenerateUploadTemplate.xlsx';

export const DELIVERY_DISPATCH_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/DeliveryDispatchUploadTemplate.xlsx';

export const EVENT_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/EventUploadTemplate.xlsx';

export const POINT_GENERATE_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/PointGenerateUploadTemplate.xlsx';

export const PRODUCT_DISCOUNT_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/ProductDiscountUploadTemplate.xlsx';

export const PRODUCT_UPDATE_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/ProductUpdateTemplate.xlsx';

export const PRODUCT_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/ProductUploadTemplate.xlsx';

export const RECOMMEND_BRAND_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/RecommendBrandUploadTemplate.xlsx';

export const REVIEW_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/ReviewUploadTemplate.xlsx';

export const SEARCH_WORD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/SearchWordUploadTemplate.xlsx';

export const TAG_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/TagUploadTemplate.xlsx';

export const MULTI_CHANNEL_ORDER_UPLOAD_TEMPLATE_XLSX_URL =
  'https://amondz.s3.ap-northeast-2.amazonaws.com/static/excel/admin/MultiChannelOrderItemUploadTemplate.xlsx';
